import { useEffect, useContext } from 'react';
import { Hidden, LinearProgress, Grid } from '@material-ui/core';
import { TablesProvider, TablesContext, TableValueType } from './TablesContext';
import { NavContext } from '../../../contexts';
import { TableList, TableSelector, TableValueList } from './components';
import { makeStyles } from '@material-ui/core/styles';
import { DbType } from '../../../../helpers/Common';

const useStyles = makeStyles((theme) => ({
    root: {
    },
    progress: {
        marginBottom: theme.spacing(2)
    }
}));

const PageContent = (props) => {
    const { addBreadcrumbToken } = useContext(NavContext);
    const classes = useStyles();
    
    const { 
        state,
        isLoadingTableDefs,
        isLoadingRelTable,
        getTableDefinitions,
        getRelatedTable,
        resetRelatedTable,
        getTableValues
    } = useContext(TablesContext);

    const loadMoreHandler = (tableId, searchText, showObsolete, pageIndex, pageSize) => {
        if (tableId) {          
            const table = state.tables.find(x => x.tableDefinitionId === tableId);

            if (table) {  
                if (table.relatedTable)
                    getRelatedTable(table.relatedTable.tableDefinitionId, DbType.ECC);
                else
                    resetRelatedTable();

                getTableValues(tableId, DbType.ECC, searchText, showObsolete, pageIndex, pageSize);
            }
        }
    };

    useEffect(() => {
        addBreadcrumbToken("Local Tables ECC")
        getTableDefinitions(DbType.ECC);
    }, []);

    return (
        <>
            {
                (
                    //isLoadingTableValues||
                    isLoadingTableDefs ||
                    isLoadingRelTable
                ) &&
                <LinearProgress
                    color="primary"
                    className={classes.progress}
                />
            }

            {
                state.tables.length > 0 &&
                <Grid container spacing={2}>
                    <Hidden lgDown>
                        <Grid item lg={3}>
                            <TableList
                                tableValueType={TableValueType.Local}
                                dbType={DbType.ECC}
                            />
                        </Grid>
                        <Grid item lg={9}>
                            <TableValueList 
                                tableValueType={TableValueType.Local}
                                onLoadMore={loadMoreHandler}
                                dbType={DbType.ECC}
                            />
                        </Grid>
                    </Hidden>
                    <Hidden xlUp>
                        <Grid item xs={12}>
                            <TableSelector
                                tableValueType={TableValueType.Local}
                                dbType={DbType.ECC}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TableValueList 
                                tableValueType={TableValueType.Local}
                                onLoadMore={loadMoreHandler}
                                dbType={DbType.ECC}
                            />
                        </Grid>
                    </Hidden>
                </Grid>
            }
        </>
    );
};

export const LocalTablesEccPage = (props): JSX.Element =>
    <TablesProvider>
        <PageContent />
    </TablesProvider>;